import React from "react";
import {showErrorPopup} from "../../Redux/content-reducer";
import {connect} from "react-redux";
import {ErrorHandle} from "./ErrorHandle";

let mapStateToProps = (state) => {
    return {
        data: {
            errorBody: state.contentData.errorBody,
            isErrorPopupShow: state.contentData.isErrorPopupShow
        }
    }
};

let mapDispatchToProps = {showErrorPopup};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorHandle);